module.exports = __webpack_public_path__ + "static/media/postcardRetro4.c23d9a0d.jpg";